import { useContextWithValidation } from '@adsk/alloy-react-context';
import { SuspenseContext } from '@adsk/alloy-react-suspense';
export const useCheckSuspenseSetup = _ref => {
  let {
    internalUsage
  } = _ref;
  useContextWithValidation(SuspenseContext, {
    hook: 'useTranslation',
    provider: 'AlloySuspense',
    shouldThrowError: internalUsage
  });
};
//# sourceMappingURL=useSuspense.js.map